export default __webpack_public_path__ + "dc54c04bf6bf24c73c5ad3622a020beb.wasm";